var _vars = require('./vars')._vars;

/**
 * Parse and validate SCG parameter from URL
 * @returns {string|null} - Clean SCG value or null if invalid
 */
function parseSCGFromUrl() {
    const params = new URLSearchParams(window.location.search);
    var scgRaw = params.get('scg');

    // Validate and clean scg parameter (lead_concept)
    var scgClean = null;
    if (scgRaw) {
        var trimmed = scgRaw.trim();
        // Remove quotes if present and trim again
        if ((trimmed.startsWith('"') && trimmed.endsWith('"')) || 
            (trimmed.startsWith("'") && trimmed.endsWith("'"))) {
            trimmed = trimmed.slice(1, -1).trim();
        }
        
        // Only return valid, non-empty values that aren't common invalid strings
        if (trimmed !== '' && 
            trimmed.length > 0 &&
            !/^\s*$/.test(trimmed) &&  // Reject whitespace-only values
            trimmed.toLowerCase() !== 'null' && 
            trimmed.toLowerCase() !== 'none' && 
            trimmed.toLowerCase() !== 'undefined' &&
            trimmed !== '0' &&  // Reject string "0"
            /^\d+$/.test(trimmed)) {  // Must be numeric (digits only)
            scgClean = trimmed;
        }
    }

    return scgClean;
}

/**
 * Set lead concept for DFP targeting
 * @param {string} conceptValue - The concept value to set
 * @param {string} source - Source of the concept ('url' or 'api')
 */
function setLeadConcept(conceptValue, source) {
    // Enhanced validation for concept value - must not be null, undefined, empty, whitespace, or invalid
    var trimmed = conceptValue;
    
    // Handle string values - trim and remove quotes if present
    if (typeof conceptValue === 'string') {
        trimmed = conceptValue.trim();
        // Remove quotes if present and trim again
        if ((trimmed.startsWith('"') && trimmed.endsWith('"')) || 
            (trimmed.startsWith("'") && trimmed.endsWith("'"))) {
            trimmed = trimmed.slice(1, -1).trim();
        }
    }
    
    var isValidValue = conceptValue && 
                      typeof conceptValue === 'string' && 
                      trimmed !== '' && 
                      trimmed.length > 0 &&
                      !/^\s*$/.test(trimmed) &&  // Reject whitespace-only values
                      trimmed.toLowerCase() !== 'null' && 
                      trimmed.toLowerCase() !== 'none' && 
                      trimmed.toLowerCase() !== 'undefined' &&
                      trimmed !== '0' &&  // Reject string "0"
                      /^\d+$/.test(trimmed);  // Must be numeric (digits only)
    
    // Only execute on full-width landing page and with valid value
    if (!isValidValue || !_vars.isFullPage) {
        console.log('Lead concept skipped - not full-width page or invalid value:', conceptValue, _vars.isFullPage);
        return;
    }
    
    // Use the cleaned/trimmed value
    conceptValue = trimmed;
    
    try {
        // Always set PageMetadata.pageSegVars.scg for both URL and API sources
        if (typeof PageMetadata !== 'undefined' && PageMetadata.pageSegVars) {
            PageMetadata.pageSegVars.scg = conceptValue;
            console.log('Lead concept set in PageMetadata.pageSegVars.scg:', conceptValue, 'from', source);
        }
        
        // Also call adLib.gpt.setPageTarget for API sources or as backup
        if (window.adLib &&
            window.adLib.gpt &&
            typeof window.adLib.gpt.setPageTarget === 'function') {
            window.adLib.gpt.setPageTarget('scg', conceptValue);
            console.log('Lead concept set via window.adLib.gpt.setPageTarget:', conceptValue, 'from', source);
        }
        
        // Update stored value (but don't use it for blocking future updates)
        _vars.leadConcept = {
            value: conceptValue,
            source: source // 'url' or 'api'
        };
        
        console.log('Lead concept successfully set:', conceptValue, 'from', source);
		window.dispatchEvent(new CustomEvent('aiEvtScgSet', {
		  detail: {
			'source': source,
			qnum: document.querySelectorAll('.ai-search-question').length
		  }
		}));
    } catch (error) {
        console.error('Error setting lead concept:', error);
    }
}

/**
 * Initialize SCG from URL parameters
 * Should be called early in the initialization process
 */
function initSCGFromUrl() {
    // Only process SCG on full-width landing pages
    var fullWidthEl = document.querySelector('.ai-search-full-width-container');
    if (!fullWidthEl) {
        return;
    }

    // PDQ requires BOTH query AND scg params in URL.
    // Setting lead concept from URL scg alone (without query) is not valid.
    var queryParam = new URLSearchParams(window.location.search).get('query');
    if (!queryParam || queryParam.trim() === '') {
        return;
    }

    var scgValue = parseSCGFromUrl();
    if (scgValue) {
        setLeadConcept(scgValue, 'url');
    }
}

module.exports = {
    parseSCGFromUrl: parseSCGFromUrl,
    setLeadConcept: setLeadConcept,
    initSCGFromUrl: initSCGFromUrl
};
